var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ManagedMap_first, _ManagedMap_last;
class ManagedMap extends Map {
    constructor() {
        super();
        _ManagedMap_first.set(this, void 0);
        _ManagedMap_last.set(this, void 0);
        __classPrivateFieldSet(this, _ManagedMap_first, {
            key: -1,
            value: -1,
        }, "f");
        __classPrivateFieldSet(this, _ManagedMap_last, {
            key: -1,
            value: -1,
        }, "f");
    }
    first() {
        return __classPrivateFieldGet(this, _ManagedMap_first, "f");
    }
    last() {
        return __classPrivateFieldGet(this, _ManagedMap_last, "f");
    }
    set(key, value) {
        if (!this.size) {
            __classPrivateFieldGet(this, _ManagedMap_first, "f").key = key;
            __classPrivateFieldGet(this, _ManagedMap_first, "f").value = value;
            __classPrivateFieldGet(this, _ManagedMap_last, "f").key = key;
            __classPrivateFieldGet(this, _ManagedMap_last, "f").value = value;
        }
        else {
            __classPrivateFieldGet(this, _ManagedMap_last, "f").key = key;
            __classPrivateFieldGet(this, _ManagedMap_last, "f").value = value;
        }
        super.set(key, value);
        return this;
    }
    clear() {
        __classPrivateFieldGet(this, _ManagedMap_first, "f").key = -1;
        __classPrivateFieldGet(this, _ManagedMap_first, "f").value = -1;
        __classPrivateFieldGet(this, _ManagedMap_last, "f").key = -1;
        __classPrivateFieldGet(this, _ManagedMap_last, "f").value = -1;
        super.clear();
    }
}
_ManagedMap_first = new WeakMap(), _ManagedMap_last = new WeakMap();
export default function PositionStore(endTimeRange) {
    let etr = endTimeRange;
    const positions = new ManagedMap();
    const filterPositions = () => {
        const now = Date.now();
        for (const time of positions.keys()) {
            const keep = now - time <= etr;
            if (!keep)
                positions.delete(time);
        }
    };
    return {
        set endTimeRange(value) {
            etr = value;
        },
        push(position) {
            if (positions.size && (positions.last().value * position < 0)) {
                this.clear();
            }
            positions.set(Date.now(), position);
            filterPositions();
        },
        getEndSpeed() {
            filterPositions();
            if (positions.size === 0 || positions.size === 1)
                return 0;
            const start = positions.first();
            const end = positions.last();
            return (end.value - start.value) / ((end.key - start.key) / 1000);
        },
        clear() {
            positions.clear();
        },
    };
}
;
//# sourceMappingURL=PositionStore.js.map